<template>
	<a @click="onClick" class="link_close">
		<span class="ico_cafe ico_close">닫기</span>
	</a>
</template>

<script>
	export default {
		methods: {
			onClick() {
				if (Utils.isSafari() && sessionStorage.getItem('fromAnotherPage')) {
					sessionStorage.removeItem('fromAnotherPage');
					return;
				}

				sessionStorage.removeItem('selected');
				sessionStorage.removeItem('scroll');
				sessionStorage.removeItem('fold');
				sessionStorage.removeItem('category');
				sessionStorage.removeItem('fromAnotherPage');

				location.href = `/${CAFEAPP.GRPCODE}`;
			},
		},
	}
</script>
